module.exports = __webpack_public_path__ + "e489b1e1efb4f07ea7038c6983d78f9a.pdf";